var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAscending = function SvgAscending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 12C9 11.4477 9.44772 11 10 11H11C11.5523 11 12 11.4477 12 12C12 12.5523 11.5523 13 11 13H10C9.44772 13 9 12.5523 9 12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 8C9 7.44772 9.44772 7 10 7H13C13.5523 7 14 7.44772 14 8C14 8.55228 13.5523 9 13 9H10C9.44772 9 9 8.55228 9 8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 4C9 3.44772 9.44772 3 10 3H15C15.5523 3 16 3.44772 16 4C16 4.55228 15.5523 5 15 5H10C9.44772 5 9 4.55228 9 4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2C4.55228 2 5 2.44772 5 3V13C5 13.5523 4.55228 14 4 14C3.44772 14 3 13.5523 3 13V3C3 2.44772 3.44772 2 4 2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.29274 2.29305C3.68318 1.90244 4.31634 1.9023 4.70695 2.29274L7.70695 5.29144C8.09756 5.68188 8.0977 6.31504 7.70726 6.70565C7.31682 7.09626 6.68366 7.0964 6.29305 6.70596L3.29305 3.70726C2.90244 3.31682 2.9023 2.68366 3.29274 2.29305Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.70726 2.29305C5.0977 2.68366 5.09756 3.31682 4.70695 3.70726L1.70695 6.70596C1.31634 7.0964 0.683179 7.09626 0.29274 6.70565C-0.0976999 6.31504 -0.0975622 5.68188 0.293047 5.29144L3.29305 2.29274C3.68366 1.9023 4.31682 1.90244 4.70726 2.29305Z"
  })));
};
export default SvgAscending;